export const setFixedScrollPosition = (fixed: boolean): void => {
  if (document) {
    document.body.classList.toggle('popover-open', fixed);
  }
};
